import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const card = 'bg-white rounded-2xl border border-[#E6DAC5] p-6';
const short = (d) => new Date(`${d}T00:00:00`).toLocaleDateString('en-AU', { day: 'numeric', month: 'short' });

export const TrafficChart = ({ data }) => (
  <div className={card} data-testid="traffic-chart">
    <div className="flex items-baseline justify-between mb-4">
      <h3 className="font-serif text-lg font-semibold text-[#1E1622]">Visitors &amp; page views · last 30 days</h3>
      <span className="text-xs uppercase tracking-[0.2em] text-[#C5A059]">Real visits</span>
    </div>
    <ResponsiveContainer width="100%" height={240}>
      <AreaChart data={(data || []).map((d) => ({ ...d, label: short(d.date) }))} margin={{ top: 5, right: 10, left: -20, bottom: 0 }}>
        <defs>
          <linearGradient id="gViews" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#C5A059" stopOpacity={0.35} /><stop offset="100%" stopColor="#C5A059" stopOpacity={0} /></linearGradient>
          <linearGradient id="gVisitors" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#3B164C" stopOpacity={0.35} /><stop offset="100%" stopColor="#3B164C" stopOpacity={0} /></linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#E6DAC5" />
        <XAxis dataKey="label" stroke="#1E1622" fontSize={11} interval={4} />
        <YAxis stroke="#1E1622" fontSize={11} allowDecimals={false} />
        <Tooltip />
        <Legend />
        <Area type="monotone" dataKey="page_views" name="Page views" stroke="#C5A059" fill="url(#gViews)" strokeWidth={2} />
        <Area type="monotone" dataKey="visitors" name="Visitors" stroke="#3B164C" fill="url(#gVisitors)" strokeWidth={2} />
      </AreaChart>
    </ResponsiveContainer>
  </div>
);

export const JourneyDetails = ({ journey }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
    <div className={card} data-testid="popular-paths">
      <h3 className="font-serif text-lg font-semibold text-[#1E1622] mb-4">Popular paths</h3>
      {journey?.popular_paths?.length ? journey.popular_paths.map((p, i) => (
        <div key={p.path} className="flex items-center justify-between py-2 border-b border-[#F5EFE9] last:border-0" data-testid={`popular-path-${i}`}>
          <span className="text-sm text-[#1E1622]">{p.path}</span><span className="text-sm text-[#1E1622]/60">{p.count} visits</span>
        </div>
      )) : <p className="text-sm text-[#1E1622]/50">Not enough visits yet.</p>}
    </div>
    <div className={card} data-testid="drop-off-points">
      <h3 className="font-serif text-lg font-semibold text-[#1E1622] mb-4">Where visitors leave</h3>
      {journey?.drop_off_points?.length ? journey.drop_off_points.map((d, i) => (
        <div key={d.page} className="flex items-center justify-between py-2 border-b border-[#F5EFE9] last:border-0" data-testid={`drop-off-${i}`}>
          <span className="text-sm text-[#1E1622]">{d.page}</span>
          <span className="text-sm text-[#1E1622]/60">{d.drop_off_rate}% leave here · {d.views} views</span>
        </div>
      )) : <p className="text-sm text-[#1E1622]/50">Shown once a page has at least 5 views.</p>}
    </div>
  </div>
);

export const BlogPerformance = ({ content }) => (
  <div className={card} data-testid="blog-performance">
    <h3 className="font-serif text-lg font-semibold text-[#1E1622] mb-4">Blog posts · last 30 days</h3>
    {content?.posts?.length ? (
      <table className="w-full text-sm">
        <thead><tr className="text-left text-xs uppercase tracking-wider text-[#1E1622]/50"><th className="pb-2 font-medium">Post</th><th className="pb-2 font-medium text-right">Views</th><th className="pb-2 font-medium text-right">Avg time</th><th className="pb-2 font-medium text-right">Led to a purchase</th></tr></thead>
        <tbody>
          {content.posts.map((p) => (
            <tr key={p.id} className="border-t border-[#F5EFE9]" data-testid={`blog-perf-${p.id}`}>
              <td className="py-2 pr-4 text-[#1E1622]">{p.title}</td><td className="py-2 text-right">{p.views}</td>
              <td className="py-2 text-right text-[#3B164C]">{p.avg_time}</td><td className="py-2 text-right">{p.conversions}</td>
            </tr>
          ))}
        </tbody>
      </table>
    ) : <p className="text-sm text-[#1E1622]/50">No blog posts yet.</p>}
  </div>
);
